// src/components/sounds/FixedSoundPlayer.js
import { useEffect, useState } from 'react';

const FixedSoundPlayer = ({ soundId, onClose }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, [soundId]);

  if (!soundId) return null;

  // Используем тот же базовый URL, что и в api.js
  const audioSrc = `/sound/audio/${soundId}`;

  return (
    <div className="fixed-sound-player">
      <div className="fixed-sound-player-content">
        {loading ? (
            <span className="text-muted">Загрузка...</span>
        ) : (
            <audio
                controls
                src={audioSrc}
                className="fixed-sound-player-audio"
                onLoadedData={() => setLoading(false)}
            />
        )}
        <button className="text-modal-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default FixedSoundPlayer;


